import React from 'react';
import PropTypes from 'prop-types';

export default function BankPreview({ paymentMethodOptions }) {
  return (
    <div className="w-100 h-100 border rounded-5 p-5">
      <h5>ACH direct deposit</h5>

      <dl>
        <dt className="small fw-light">Bank name</dt>
        <dd className="fw-semibold">{paymentMethodOptions.bank_name}</dd>

        <dt className="small fw-light">Account number</dt>
        <dd className="fw-semibold">
          **** **** ****
          {paymentMethodOptions.last4}
        </dd>
      </dl>
    </div>
  );
}

BankPreview.propTypes = {
  paymentMethodOptions: PropTypes.object.isRequired,
};
